import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import ExternalLink from '../../components/Link/ExternalLink';
import { useSiteUrl } from '../../graphql/hooks';

const QuickbooksData = () => {
  const images = useStaticQuery(graphql`
    query {
      metaImage: file(
        relativePath: { eq: "assets/img/quickbooks/meta-image.jpg" }
      ) {
        ...localImageHero
      }
      heroImage: file(
        relativePath: { eq: "assets/img/quickbooks/landing-page.jpg" }
      ) {
        ...localImageHero
      }
      neonWorkshopsThumbnail: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-thumb.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshops1: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-1.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshops2: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshops3: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-3.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide1: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-1-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide2: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-2-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide3: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-3-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide4: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-4-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide5: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-5-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide6: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-6-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide7: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-7-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide8: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-8-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      neonWorkshopsSlide9: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-9-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLivingThumbnail: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-thumbnail.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-thumb.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving1: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-1.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving2: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving3: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-3.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving4: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-4.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving5: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-5.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving6: file(
        relativePath: {
          eq: "assets/img/quickbooks/papillon-living-6-slide.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving7: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-7.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving8: file(
        relativePath: {
          eq: "assets/img/quickbooks/papillon-living-8-slide.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      papillonLiving9: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-9.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestThumbnail: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-thumb.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWest1: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-1.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWest2: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWest3: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-3.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide1: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-1-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide2: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-2-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide3: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-3-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide4: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-4-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide5: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-5-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide6: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-6-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide7: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-7-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide8: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-8-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      potteryWestSlide9: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-9-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffleThumbnail: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-1.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-thumb.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle1: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-8.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle2: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle3: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-3.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle4: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-4.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle5: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-12-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle6: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-6-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle7: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-7.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle8: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-11.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle9: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-9-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle10: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-10b.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle13: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-13-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle14: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-14-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      utterWaffle15: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-15-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel1: file(
        relativePath: { eq: "assets/img/quickbooks/neon-workshops-1-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel2: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-5.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel3: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-1.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel4: file(
        relativePath: { eq: "assets/img/quickbooks/pottery-west-1-slide.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel5: file(
        relativePath: { eq: "assets/img/quickbooks/utter-waffle-2.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
      landingPageCarousel6: file(
        relativePath: { eq: "assets/img/quickbooks/papillon-living-10.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
        }
      }
    }
  `);
  const QUICKBOOKS = {
    caseStudies: [
      {
        carousel: [
          {
            alt: '',
            image: images.papillonLiving3.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.papillonLiving1.childImageSharp.gatsbyImageData,
          },

          {
            alt: '',
            image: images.papillonLiving6.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.papillonLiving7.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.papillonLiving5.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.papillonLiving8.childImageSharp.gatsbyImageData,
          },
        ],
        cta: (
          <p>
            <ExternalLink href="https://quickbooks.intuit.com/uk/business-type/startups/">
              Learn more
            </ExternalLink>{' '}
            about how QuickBooks can help you make good decisions from day one.
          </p>
        ),
        image1: images.papillonLiving.childImageSharp.gatsbyImageData,
        image2: images.papillonLiving2.childImageSharp.gatsbyImageData,
        image3: images.papillonLiving9.childImageSharp.gatsbyImageData,
        image4: images.papillonLiving4.childImageSharp.gatsbyImageData,
        introduction: {
          caption: `HOMEWARE | BRIGHTON`,
          standfirst: `Stephen Anderson of interiors store Papillon Living shares some of his key business learnings –  from sticking to your convictions and taking risks to keeping your paperwork organized.`,
          thumbTitle: `Papillon Living: from launch to long haul`,
          thumbnail:
            images.papillonLivingThumbnail.childImageSharp.gatsbyImageData,
          title: `Papillon Living: from launch to long haul`,
          videoCredits: (
            <div>
              <div>Director | Kris Rimmer</div>
              <div>Producer | Thomas Ashton</div>
              <div>
                Production |{' '}
                <ExternalLink href="https://www.vince.co.uk/">
                  VINCE
                </ExternalLink>
              </div>
            </div>
          ),
          videoDescription: `Papillon Living is an eclectic homeware emporium that opened in 2009. For co-founders Stephen Anderson and  Andrew Allen, the brand was originally a side project to their main business, an actor's agency, but the store has stayed the course.`,
        },
        metadata: {
          description: `Stephen Anderson of interiors store Papillon Living shares some of his key business learnings –  from sticking to your convictions and taking risks to keeping your paperwork organized.`,
          image: `${useSiteUrl()}${images.papillonLivingThumbnail.publicURL}`,
          title: `Papillon Living: from launch to long haul`,
          twitterCard: 'summary_large_image',
        },
        pullquote1: {
          attribution: `Stephen Anderson`,
          quote: `‘Just follow it through, because you only regret what you don't do.’`,
        },
        section1: {
          text: (
            <>
              <p>
                A lot has changed for retailers over the past two decades. Ways
                of working have evolved and new technologies have entered the
                market, along with a flurry of fast-paced, agile newcomers.
              </p>
              <p>
                On the face of it, you'd be forgiven for thinking that a
                14-year-old business wouldn't understand what it takes to launch
                a new shop these days. But a lot can be learned from setting up
                a business in a tough economic environment – as shown by{' '}
                <ExternalLink href="https://papillonliving.com/">
                  Papillon Living
                </ExternalLink>
                , an eclectic homeware emporium in Brighton that opened during
                the last financial crisis.
              </p>
              <p>
                ‘Whether [there's] a recession or not, if your offering is
                always quality-focused and service-focused, then you'll be
                successful,’ says Papillon Living's co-founder Stephen Anderson.
                ‘And it may take some time. But it's one of those learnings to
                share – to not give up, to not doubt yourself and just stay the
                course.’
              </p>
              <p>
                Papillon Living started in 2009 as a side business to an actor's
                agency that Stephen ran with his partner Andrew Allen. Back
                then, everyone advised them against opening a retail store and
                giving up well-paid jobs to take on such a big risk. ‘But
                sometimes you just have to go with the flow,’ says Stephen, who
                previously ran a software company. ‘If you really feel your
                offering is going to be successful, [...] if you have the
                conviction, if you have the inspiration and the impulse to do
                something, just follow it through, because you only regret what
                you don't do.’
              </p>
            </>
          ),
          title: `Taking the leap`,
        },
        section2: {
          text: (
            <>
              <p>
                Papillon Living has changed a lot through the years, moving
                premises twice and even setting up its own manufacturing arm,{' '}
                <ExternalLink href="https://www.houseofalchemy.co.uk/">
                  House of Alchemy
                </ExternalLink>
                , which makes perfumes, candles and diffusers. But business is
                all about change, and being adaptable means having your ‘fingers
                on the pulse’ when it comes to the wider economy, Stephen
                explains.
              </p>
              <p>
                ‘Undoubtedly, there'll be businesses that suffer [during a
                recession], but you have to constantly evolve and change. It's
                all about reading what's going on out there, supporting your
                customers, not being greedy with prices or complacent with
                products and bringing new products. You're being innovative and
                constantly offering something different: quality at an
                affordable price. So, if you can bring those factors into it,
                then you'll carry on surviving – perhaps on reduced margins, but
                [it's] far better to be in business on a reduced margin [than]
                not be in business at all.’
              </p>
            </>
          ),
          title: ``,
        },
        section3: {
          text: (
            <>
              <p>
                In the early days, both Stephen and Andrew were focused on
                front-of-house operations, looking after people as they entered
                the store, buying the right stock and making sure that
                everything customers interacted with was organized and
                well-presented. But, behind the scenes, when it came to
                paperwork and the financials, it was a different story – ‘a bit
                like the duck on the water, with the legs scrambling
                underneath,’ Stephen admits.
              </p>
              <p>
                ‘My accountant was forever chasing me for paperwork, doing VAT
                returns and so on. We got some late-filing penalties from HMRC
                [the UK's tax office], just because we didn't have paperwork
                organized or know where it was, scrambling at the last moment
                and not capturing all the information. So, late to the game,
                after taking a few years of bruises and knocks, we adopted{' '}
                <ExternalLink href="https://quickbooks.intuit.com/uk/">
                  QuickBooks
                </ExternalLink>{' '}
                as a way of bringing some order to our business.’
              </p>
              <p>
                He continues: ‘That was a lifesaver and a game-changer because
                it meant that, for once, we actually had information that was
                accessible – for our accounting firm and for us – and we knew
                where everything was. What was not so great was realizing that
                we could have done that much sooner and not had such an
                expensive process.’
              </p>
            </>
          ),
          title: `Bringing order to the business`,
        },
        section4: {
          text: (
            <>
              <p>
                For new business owners, Stephen has one crucial bit of advice:
                focus on what you do best and delegate the tasks you feel less
                passionate about. In Stephen's case, that was financial
                reporting. ‘For me, that was always a bit of a chore. I never
                really enjoyed it. There was always something more pressing to
                do,’ he says.
              </p>
              <p>
                ‘To be able to have a system in place where you could just press
                a button and have accurate reporting – that was a godsend. I'd
                definitely recommend that and bring that in as early as
                possible. Don't try to do everything yourself.’
              </p>
              <p>
                For Stephen, one of the most important things in any business is
                financial control. ‘Know what your paperwork trail is. Whether
                that's digital or manual, have a handle on it,’ he says. It's
                not only important from an admin point of view, but it can
                provide a wealth of useful information. ‘Whether that's finding
                out what your bestsellers are, getting rid of lines that take a
                long time to sell or finding you're spending too much on
                packaging,’ Stephen explains, ‘you can only realize that through
                financial controls and a software package like QuickBooks to
                give you that data.’
              </p>
              <p>
                Having the knowledge to make informed decisions is an important
                part of running a retail store in today's economic environment.
                But, sometimes, it's about having the confidence to go with your
                gut while others are dialing back on risk. And, according to
                Stephen, there's great opportunity in these moments. ‘Fortune
                favors the brave,’ he says. ‘If you don't do something when you
                have the impulse to do it, then you just never do it. If we
                listened to the naysayers in 2009, we wouldn't be in business
                today.’
              </p>
            </>
          ),
          title: `Divide and conquer`,
        },
        sliderCaption: `Papillon Living is a key part of Brighton's retail scene.`,
        url: '/partnerships/quickbooks-mailchimp/papillon-living',
      },
      {
        carousel: [
          {
            alt: '',
            image: images.utterWaffle5.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle6.childImageSharp.gatsbyImageData,
          },

          {
            alt: '',
            image: images.utterWaffle7.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle8.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle9.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle13.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle15.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.utterWaffle14.childImageSharp.gatsbyImageData,
          },
        ],
        cta: (
          <p>
            <ExternalLink href="https://quickbooks.intuit.com/uk/business-type/startups/">
              Learn more
            </ExternalLink>{' '}
            about how QuickBooks can help you make good decisions from day one.
          </p>
        ),
        image1: images.utterWaffle1.childImageSharp.gatsbyImageData,
        image2: images.utterWaffle2.childImageSharp.gatsbyImageData,
        image3: images.utterWaffle3.childImageSharp.gatsbyImageData,
        image4: images.utterWaffle10.childImageSharp.gatsbyImageData,
        introduction: {
          caption: `FOOD AND DRINK | LONDON`,
          standfirst: `The early days of launching a small business can be chaotic. James Timmins and Julia Jefferis explain how they grew their gourmet waffle company into a professional operation.`,
          thumbTitle: `Utter Waffle: four wheels to four walls`,
          thumbnail:
            images.utterWaffleThumbnail.childImageSharp.gatsbyImageData,
          title: `Utter Waffle: four wheels to four walls`,
          videoCredits: (
            <>
              <div>Director | Kris Rimmer</div>
              <div>Producer | Thomas Ashton</div>
              <div>
                Production |{' '}
                <ExternalLink href="https://www.vince.co.uk/">
                  VINCE
                </ExternalLink>
              </div>
            </>
          ),
          videoDescription: `Launched in 2019, Utter Waffle is operated by co-founders James Timmins and Julia Jefferis. The award-winning brunch and street-food restaurant serves savory and sweet waffles for events and markets across the UK and opened a permanent restaurant in 2021.`,
        },
        metadata: {
          description: `The early days of launching a small business can be chaotic. James Timmins and Julia Jefferis explain how they grew their gourmet waffle company into a professional operation.`,
          image: `${useSiteUrl()}${images.utterWaffleThumbnail.publicURL}`,
          title: `Utter Waffle: four wheels to four walls`,
          twitterCard: 'summary_large_image',
        },
        pullquote1: {
          attribution: `James Timmins`,
          quote: `‘That's probably the only thing that hasn't changed –  we all still fake it till you make it. And I think it's going pretty well so far.’`,
        },
        pullquote2: {
          attribution: `James Timmins`,
          quote: `‘Freeing up time and spreading that workload has been by far the biggest learning.’`,
        },
        section1: {
          text: (
            <>
              <p>
                From pitching up its first food truck outside London office
                blocks to building a 16-person restaurant, catering and events
                business,{' '}
                <ExternalLink href="https://utterwaffle.co.uk/">
                  Utter Waffle
                </ExternalLink>{' '}
                has come a long way since its inception in 2019. But, for
                co-founders James Timmins and Julia Jefferis, success wasn't
                always a given. It came about through trial, error and a whole
                lot of guesswork.
              </p>
              <p>
                ‘If any entrepreneur tells you they know what they're doing,
                they're lying,’ says James. ‘I think one of the biggest
                misconceptions – particularly [about] small businesses – is that
                we have any idea what we're doing. That's probably the only
                thing that hasn't changed – we all still fake it till you make
                it. And I think it's going pretty well so far.’
              </p>
              <p>
                Friends James and Julia spent six months traveling South America
                and, after seeing the popularity of savory crepes in Colombia,
                they were inspired to bring back something similar. ‘It was a
                very social, fresh, cheap and interesting food. But crepes were
                a bit done, so we discovered its crispier, far more attractive
                cousin: the waffle,’ James says.
              </p>
              <p>
                But it wasn't an easy ride, James explains. ‘We tried selling to
                people in office blocks. Trying to persuade a man in a suit to
                buy a savory waffle for his lunch was a struggle.’
              </p>
              <p>
                Julia recalls their first day of trading. ‘We turned out of my
                road and two of our massive batter dishes fell out [of] the
                fridge and all over our brand-new van. We sat in silence for
                about 20 minutes,’ she says. ‘I was crying. It was horrendous,’
                says James.
              </p>
              <p>
                Fast forward to today, Utter Waffle is a four-time British
                Street Food Awards winner, opening a permanent site in south
                London's Herne Hill in May 2021. Meanwhile, its two food trucks
                have held spots at world-famous venues like London's National
                Theatre and Kew Gardens, as well as large-scale festivals,
                celebrity bookings and weddings.
              </p>
            </>
          ),
          title: `Best-laid plans`,
        },
        section2: {
          text: (
            <>
              <p>
                When James and Julia started out, they often relied on manual
                spreadsheets to keep track of the business. ‘It was a very
                elementary version of what we do now,’ James says. But, as the
                business has expanded and diversified its operations, the pair
                have had to work smarter and more efficiently. ‘We'd go through
                periods – like six months after an event – being like, “They've
                not paid us.” Which sounds crazy but, when you've got lots of
                money incoming and outgoing, you miss things,’ James says.
              </p>
              <p>
                In search of a way to get more organized, Utter Waffle signed up
                to QuickBooks in early 2021, which has helped the pair keep
                track of their growing business. ‘Because now we've got lots of
                different revenue streams and profit centers, it's very easy to
                miss things. Also, having the restaurant came with suddenly
                employing 12 people. It expanded our business in every single
                area. Without{' '}
                <ExternalLink href="https://quickbooks.intuit.com/uk/">
                  QuickBooks
                </ExternalLink>
                , I don't know how [we'd do it],’ James says. ‘I'd look a lot
                older, definitely.’
              </p>
              <p>
                One of the most helpful QuickBooks tools for Utter Waffle has
                been the receipt capture feature, according to Julia. ‘Any
                receipts that you have when you're on the go, you snap it – it
                uploads it straight to your software and it matches all your
                transactions, which is super helpful,’ she says.
              </p>
            </>
          ),
          title: `Growing the smart way`,
        },
        section3: {
          text: (
            <>
              <p>
                Features like these not only give the co-founders a clearer
                picture of operations day to day, but they've also given them
                back ‘loads of time’, Julia says. ‘We used to make our invoices
                ourselves, but now it's all digitalized and [QuickBooks] sends
                it to the client for you, sending reminders to us and the
                client,’ she says.
              </p>
              <p>
                As a result, the pair have been able to concentrate on other
                areas of the business, James explains. ‘The software enables us
                to use that time that was going to be spent invoicing and
                looking at receipts to do a bit more – the marketing, the social
                media, looking after the staff, sitting down and making sure
                that they're OK.’
              </p>
              <p>
                As the business has grown, so have the owners, and James says
                one milestone has been figuring out how to delegate as a
                manager. ‘I know we all think that we're the best at doing every
                job [...] So, for me, training and empowering people, freeing up
                time and spreading that workload has been by far the biggest
                learning.’
              </p>
            </>
          ),
          title: `Freeing up time`,
        },
        section4: {
          text: (
            <>
              <p>
                But it's not always that easy. ‘What is our baby and everything
                we know, we have to give control to somebody else. For me,
                that's the hardest part – to say I won't be there and everything
                will be as we built it and we work for,’ Julia says. ‘But it's
                so exciting, at the same time, having things run and not needing
                to be there every day.’
              </p>
              <p>
                Delegating and empowering their team will be essential if Utter
                Waffle is to keep growing in the way that James and Julia want,
                expanding into a micro chain around London. ‘I personally would
                never want to see it on every high street in the UK,’ James
                says. ‘But I do like the idea of having eight to 12 of them
                throughout London or the outskirts, so that we can still hold on
                to that independent feel, that unique selling point. That, to
                me, is a massive, massive dream.’
              </p>
            </>
          ),
          title: `Calling time on control`,
        },
        sliderCaption: `Utter waffle's restaurant opened in 2021.`,
        url: '/partnerships/quickbooks-mailchimp/utter-waffle',
      },
      {
        carousel: [
          {
            alt: '',
            image: images.potteryWestSlide1.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide2.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide3.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide4.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide5.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide6.childImageSharp.gatsbyImageData,
          },
          // {
          //   alt: '',
          //   image: images.potteryWestSlide7.childImageSharp.gatsbyImageData,
          // },
          {
            alt: '',
            image: images.potteryWestSlide8.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.potteryWestSlide9.childImageSharp.gatsbyImageData,
          },
        ],
        cta: (
          <>
            <div className="partnerships-global-margin-bottom--tiny">
              <p>
                See how bringing your Mailchimp marketing tools and QuickBooks
                invoice data together in one place* can help make your campaigns
                more powerful—and help you get back to doing your own thing.
              </p>
            </div>
            <p>
              <ExternalLink href="https://mailchimp.com/landers/quickbooks/uk/">
                Get started now
              </ExternalLink>
            </p>
          </>
        ),
        image1: images.potteryWest1.childImageSharp.gatsbyImageData,
        image2: images.potteryWest2.childImageSharp.gatsbyImageData,
        image3: images.potteryWest3.childImageSharp.gatsbyImageData,
        introduction: {
          caption: `CERAMICS | SHEFFIELD`,
          standfirst: `See how this ceramics studio uses Mailchimp automations and segmentation to send the right message and QuickBooks to help the business side run smoothly.`,
          thumbTitle: `Pottery West: balancing art and business`,
          thumbnail:
            images.potteryWestThumbnail.childImageSharp.gatsbyImageData,
          title: `Pottery West balances art and business`,
          videoCredits: (
            <>
              <div>Director | Kris Rimmer</div>
              <div>Producer | Thomas Ashton</div>
              <div>
                Production |{' '}
                <ExternalLink href="https://www.vince.co.uk/">
                  VINCE
                </ExternalLink>
              </div>
            </>
          ),
          videoDescription: `**Subjects were compensated for their participation in this article.`,
        },
        metadata: {
          description: `See how this ceramics studio uses Mailchimp automations and segmentation to send the right message and QuickBooks to help the business side run smoothly.`,
          image: `https://images.ctfassets.net/l893v89mix1e/5gbFVXotsXT3tA6YGqgAT0/029581da4690aeb6cc273fd5b4781e31/mm_hires_courier_potterywest_008-min.jpg?h=250`,
          title: `Pottery West balances art and business`,
          twitterCard: 'summary_large_image',
        },
        pullquote1: {
          attribution: `– Catherine West`,
          quote: `‘Mailchimp really helps us to build that relationship of trust, even if it's over a few years.’ `,
        },
        pullquote2: {
          attribution: `– Catherine West`,
          quote: `‘I'm not sure how we would work out the VAT without using QuickBooks.’`,
        },
        pullquote3: {
          attribution: `– Catherine West`,
          quote: `‘QuickBooks and Mailchimp as one integration could be really valuable and efficient for us.’`,
        },
        section1: {
          text: (
            <>
              <p>
                Scroll through Pottery West's Instagram feed and you'll see post
                after post showing the process of making each handcrafted piece
                and the story behind it. Though their audience spans gender, age
                and location, co-founders Matt and Catherine West understand
                that everyone has a common interest in handmade items.
              </p>
              <p>
                Matt and Catherine ‌both pursued creative degrees. After
                graduation, Matt worked as a baker and Catherine as a marketing
                and communications professional. They combined their creativity,
                love of the culinary arts, marketing experience and desire to
                work with their hands and founded{' '}
                <ExternalLink href="https://potterywest.co.uk/">
                  Pottery West
                </ExternalLink>{' '}
                in Sheffield, England, in 2015.
              </p>
              <p>
                They began as part-time pottery makers, but their passion and
                dedication to the craft inspired them to make it a full-time
                endeavor. Matt says: ‘Once we started making pots, it became
                obvious that we wanted this to become our career, and so the
                business very quickly followed. We started going to fairs and
                setting up a website and, very organically, the business grew
                from there.’
              </p>
            </>
          ),
          title: ``,
        },
        section2: {
          text: (
            <>
              <p>
                Matt says: ‘One of our general goals for our business is to have
                a fundamental product range of tableware that people use – and
                also to have a more creative side of the business, where we're
                making one-off pieces and maybe pieces that people would want to
                start collecting. In terms of how our business is going to
                shift, we'd like to have people who would come back to us to
                purchase.’
              </p>
              <p>
                At one point, wholesale made up most of their income, but they
                wanted to diversify. Their goal was to gain and retain more
                customers without having to expand production. With the addition
                of workshops and a focused effort on direct-to-consumer (DTC)
                sales, they now sell mostly DTC and only a small percentage to
                wholesalers. And, in 2021, they found that less than a quarter
                of their customers came back and bought from them again but, by
                2022, this had more than doubled.
              </p>
            </>
          ),
          title: `Company goals`,
        },
        section3: {
          text: (
            <>
              <p>
                Catherine says they used to use Mailchimp for only one type of
                email – one sent to all their contacts with a single objective,
                like promoting a new series of items in stock with a link to
                their store. Now, they've found success in{' '}
                <ExternalLink href="https://mailchimp.com/features/segmentation/?currency=GBP">
                  segmenting their audiences and personalizing messages
                </ExternalLink>{' '}
                based on behavior or interest. They can communicate differently
                with people based on where or how they signed up for the list,
                whether it was at a fair (and which fair location) or the pop-up
                form on their website. They can even segment by new and
                returning customers, and whether they're interested in products
                or workshops.
              </p>

              <p>
                They employ{' '}
                <ExternalLink href="https://mailchimp.com/features/automations/customer-journey-builder/">
                  automations
                </ExternalLink>{' '}
                to communicate with customers, too. Catherine says: ‘When
                someone subscribes, they'll get a{' '}
                <ExternalLink href="https://mailchimp.com/features/automated-welcome-email/">
                  welcome email
                </ExternalLink>{' '}
                with a discount code to tempt them to purchase from us. Then, a
                few days later, they'll get a second email with a little bit
                more information about Pottery West, our story and our values.
                And based on whether that person has engaged or made a purchase,
                we'll use the tag that's created.’ All this information helps
                them plan campaigns for the future.
              </p>

              <p>
                They pay close attention to the non-customers on their list as
                well. ‘Something that we've learned over the past few years is
                that the journey from joining our mailing list to becoming a
                customer can be quite a long one,’ says Catherine. ‘Mailchimp
                really helps us to build that relationship of trust, even if
                it's over a few years.’
              </p>
            </>
          ),
          title: `Talking with customers where they are with Mailchimp`,
        },
        section4: {
          text: (
            <>
              <p>
                Pottery West uses QuickBooks to get a comprehensive view of how
                the business is doing. Matt says: ‘It's really useful for us to
                have a look at the general business accounting overview, such as
                the profit and loss account, which is something that we might
                see only once a year, once our accountant is given our
                end-of-year account.’ He continues: ‘We use QuickBooks for
                filing expenses, raising invoices and processing VAT
                information.’
              </p>
              <p>
                VAT (a charge similar to sales tax in the US) is included in the
                total price for an item. Catherine says: ‘I'm not sure how we
                would work out the VAT without using QuickBooks.’
              </p>
              <p>
                Their accountant has access, so it's easy for her to get all the
                information she needs without having to come to the owners for
                it. ‘It makes looking at our business accounting much more
                straightforward,’ says Matt.
              </p>
            </>
          ),
          title: `Accessing real-time financial information with QuickBooks Online Plus`,
        },
        section5: {
          text: (
            <>
              <p>
                Mailchimp offers an integration with QuickBooks that syncs
                real-time financial data from QuickBooks Online into Mailchimp,
                offering the opportunity to market more effectively. After
                learning the value of the integration, Matt says, ‘Having both
                marketing and sales information together could be really useful
                to analyze how an email campaign has done and to see how this
                has affected sales and what pieces we're making that people are
                interested in.’
              </p>
              <p>
                ‘At the moment, we gather our sales and marketing information
                from lots of different sources,’ adds Catherine. ‘Having all the
                information in both QuickBooks and Mailchimp as one integration
                could be really valuable and efficient for us.’
              </p>
            </>
          ),
          title: (
            <>
              Using Mailchimp and QuickBooks together
              <small className="partnerships-quickbooks-mailchimp__asterisk">
                *
              </small>
            </>
          ),
        },
        section6: {
          text: (
            <>
              <p>
                When they started Pottery West as a creative venture, Matt said
                they were so wrapped up in making the pots, it was easy to
                forget about the business side. He advises other creatives to
                have a plan and know where they want to go.
              </p>
              <p>
                Catherine thinks it's important to stay true to who you are.
                ‘That's quite a hard thing to do as a business and a maker – to
                do the thing that you want to do – because there's a lot of
                influence from other potters. It can be quite hard to just do
                your own thing.’
              </p>
            </>
          ),
          title: `Advice for business owners`,
        },
        section7: {
          text: (
            <p>
              *QuickBooks Online and Mailchimp sold separately. Integration
              available. Availability of features and functionality varies by
              plan type.
            </p>
          ),
        },
        sliderCaption: `Pottery West launched in 2015.`,
        url: '/partnerships/quickbooks-mailchimp/pottery-west',
      },
      {
        carousel: [
          {
            alt: '',
            image: images.neonWorkshopsSlide1.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide2.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide3.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide4.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide5.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide6.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide7.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide8.childImageSharp.gatsbyImageData,
          },
          {
            alt: '',
            image: images.neonWorkshopsSlide9.childImageSharp.gatsbyImageData,
          },
        ],
        cta: (
          <>
            <div className="partnerships-global-margin-bottom--tiny">
              <p>
                Kick off your marketing journey in a way that could save time
                ‌and bring in revenue. With Mailchimp and QuickBooks Online,
                send emails fast using synced purchase history and Mailchimp's
                drag-and-drop templates.
              </p>
            </div>
            <p>
              <ExternalLink href="https://mailchimp.com/landers/quickbooks/uk/">
                Get started now
              </ExternalLink>
            </p>
          </>
        ),
        image1: images.neonWorkshops1.childImageSharp.gatsbyImageData,
        image2: images.neonWorkshops2.childImageSharp.gatsbyImageData,
        image3: images.neonWorkshops3.childImageSharp.gatsbyImageData,
        introduction: {
          caption: `MANUFACTURING | WAKEFIELD`,
          standfirst: `See how design studio Neon Workshops markets and manages its finances so it can educate and inspire students, artists and more to create one-of-a-kind pieces.`,
          thumbTitle: `Neon Workshops: illuminating an industry`,
          thumbnail:
            images.neonWorkshopsThumbnail.childImageSharp.gatsbyImageData,
          title: `Neon art boosted by Mailchimp and QuickBooks`,
          videoCredits: (
            <>
              <p>Director | Kris Rimmer</p>
              <p>Producer | Thomas Ashton</p>
              <p>
                Production |{' '}
                <ExternalLink href="https://www.vince.co.uk/">
                  VINCE
                </ExternalLink>
              </p>
            </>
          ),
          videoDescription: `**Subject was compensated for their participation in this article.`,
        },
        metadata: {
          description: `See how design studio Neon Workshops markets and manages its finances so it can educate and inspire students, artists and more to create one-of-a-kind pieces.`,
          image: `https://images.ctfassets.net/l893v89mix1e/41S17oLNiY759xyqerOSrH/f7670fb42d4a1706344901eb48a1c240/mm_hires_courier_neonworkshops_006.jpg?h=250`,
          title: `Neon art boosted by Mailchimp and QuickBooks`,
          twitterCard: 'summary_large_image',
        },
        pullquote1: {
          attribution: `– Richard Wheater`,
          quote: `‘We use QuickBooks on a near-daily basis. I can, at a glance, log in and see what's happening financially.’`,
        },
        pullquote2: {
          attribution: `– Richard Wheater`,
          quote: `‘Don't be afraid to go and just ask for people's advice, and don't expect to have all the answers yourself.’`,
        },
        section1: {
          text: (
            <>
              <p>
                When people think of neon, they often conjure up images of
                advertising stores, diners and Broadway shows. But, when Richard
                Wheater traveled from the UK to New York on a student exchange
                program to study glass-blowing, he developed an appreciation for
                neon as a medium for artistic expression. When he returned to
                the UK, he took a job in a commercial neon shop and began
                teaching the creative side of the craft as well.
              </p>
              <p>
                He combined his interests in creative design and teaching in
                2009 by founding{' '}
                <ExternalLink href="https://www.neonworkshops.com/">
                  Neon Workshops
                </ExternalLink>{' '}
                in Wakefield, UK. He says that the most rewarding things about
                Neon Workshops are that he gets to introduce people to neon for
                the first time and that he can use neon in ways that haven't
                been done before. ‘Neon Workshops is a product of something that
                just didn't exist,’ Richard says.
              </p>
              <p>
                In addition to producing and installing large exhibitions and
                commissions for galleries, artists, TV, film and theater, Neon
                Workshops instructs a diverse student base. ‘We've taught
                everyone from priests to long-distance lorry drivers, to people
                in the medical industry and, of course, students and creatives.’
              </p>
              <p>
                Teaching, fabrication and installation services make up the
                brand's main income streams. It also has an online store where
                people can buy products, like limited-edition neons, books or
                posters. And soon, Richard hopes to diversify the range even
                more. The brand's expanding into building and selling an
                electron bombarder (a machine that creates light) so that people
                can continue working with neon on their own after attending a
                workshop. These machines aren't just for workshop students,
                though – they'll also be aimed at colleges and universities to
                teach students the art of creating neon.
              </p>
            </>
          ),
          title: ``,
        },
        section2: {
          text: (
            <>
              <p>
                ‘Most people don't know what neon is, where it came from or what
                it can actually do,’ Richard says. And, for such a niche
                business with varying customer segments, spreading a passion for
                neon and educating the public on its relevance is vital to its
                success.
              </p>
              <p>
                Neon Workshops uses Mailchimp's segmentation tools as a way to
                connect with its customers based on interests or behaviors.
                ‘Mailchimp allows Neon Workshops to target our varied audiences
                with specific information, whether we're putting out a workshop,
                running an exhibition or, more recently, about to start offering
                machines to help people create their own neon,’ says Richard.
                ‘Sometimes those newsletters will have more than one group
                that's relevant to receive those newsletters. And, for us, that
                helps reduce the amount of unsubscribes and encourages more
                clicks.’
              </p>
              <p>
                As it begins to sell the machines, it'll set up a separate
                segment to keep customers informed and engaged – Richard doesn't
                want to send the information to someone whose only interest was
                an online purchase. ‘Being able to select who we send out the
                newsletters to by departmentalizing them into groups allows us
                to target people with that relevant information – it just helps
                us have a better relationship with our customers,’ he explains.
              </p>
            </>
          ),
          title: `Bringing neon art to the masses with Mailchimp segmentation`,
        },
        section3: {
          text: (
            <>
              <p>
                ‘We use QuickBooks on a near-daily basis,’ says Richard. ‘I can,
                at a glance, log in within seconds and see what's happening
                financially. And that's priceless, to be honest.’
              </p>
              <p>
                Neon Workshops uses QuickBooks Online Plus to help make its
                financial tracking more convenient. First, it links to its
                online store and workshop registration, so those transactions
                are synced into QuickBooks*. It also syncs QuickBooks with its
                bank activity, allowing it to create invoices, make delivery
                notes and check payments. ‘We also more recently have used it to
                make it easier for clients to pay their invoices by emailing
                through QuickBooks with payment buttons,’ says Richard.
                QuickBooks also shows which invoices haven't been paid, so the
                team can reach out to those customers for payment.
              </p>
              <p>
                QuickBooks helps him grow his business, Richard says. He
                allocates codes to each income stream and can see over time how
                much money the brand made from each product or service.
                ‘QuickBooks is a useful resource for being able to see that and
                then knowing what effort to put where.’
              </p>
            </>
          ),
          title: `Managing finances more easily with QuickBooks`,
        },
        section4: {
          text: (
            <>
              <p>
                Neon Workshops currently uses a spreadsheet with information
                about customers who attended workshops, as well as people who've
                purchased from its online store – along with the amount they've
                spent. After learning about the integration available for
                Mailchimp and QuickBooks, Neon Workshops saw a benefit to using
                it to compartmentalize its customers' contact information based
                on previous purchases.
              </p>
            </>
          ),
          title: (
            <>
              Using Mailchimp and QuickBooks together
              <small className="partnerships-quickbooks-mailchimp__asterisk">
                *
              </small>
            </>
          ),
        },
        section5: {
          text: (
            <>
              <p>
                Starting a small business poses challenges for many but, for
                artists who are also business founders, it can be especially
                hard. ‘Remain determined and don't give up. There'll be times
                when you feel like everything is going against you and it's
                incredibly overwhelming,’ Richard says. ‘Don't be afraid to go
                and just ask for people's advice, and don't expect to have all
                the answers yourself.’
              </p>
            </>
          ),
          title: `Advice for business owners`,
        },
        section6: {
          text: (
            <>
              <div className="partnerships-global-margin-bottom--tiny">
                <p>
                  *QuickBooks Online and Mailchimp sold separately. Integration
                  available. Availability of features and functionality varies
                  by plan type.
                </p>
              </div>
              <p>
                *App integration available with QuickBooks. Some apps require
                third-party integration to connect to QuickBooks Commerce. In
                those instances, subscription, acceptance of the company’s
                Privacy Policy and Terms of Use, and an integration setup may be
                required. Additional fees, terms and conditions apply.
              </p>
            </>
          ),
          title: ``,
        },
        sliderCaption: `Neon Workshops has been brightening Wakefield since 2009.`,
        url: '/partnerships/quickbooks-mailchimp/neon-workshops',
      },
    ],
    cta: (
      <>
        <div className="partnerships-global-margin-bottom--tiny">
          <p>
            See how bringing your Mailchimp marketing tools and QuickBooks
            invoice data together in one place* can help make your campaigns
            more powerful—and help you get back to doing your own thing.
          </p>
        </div>
        <p>
          <ExternalLink href="https://mailchimp.com/landers/quickbooks/uk/">
            Get started now
          </ExternalLink>
        </p>
      </>
    ),
    home: {
      metadata: {
        description: `Whether it's the opening of a retail store or a food truck's first day of trading, the way in which you launch a new business can be the key to ensuring long-term success.`,
        image: `${useSiteUrl()}${images.metaImage.publicURL}`,
        title: 'Start Smart',
        twitterCard: 'summary_large_image',
      },
      text: `Whether it's the opening of a retail store or a food truck's first day of trading, the way in which you launch a new business can be the key to ensuring long-term success.`,
      title: 'Start Smart',
    },
    landingPage: {
      carousel: [
        {
          alt: '',
          image: images.landingPageCarousel1.childImageSharp.gatsbyImageData,
        },
        {
          alt: '',
          image: images.landingPageCarousel2.childImageSharp.gatsbyImageData,
        },
        {
          alt: '',
          image: images.landingPageCarousel3.childImageSharp.gatsbyImageData,
        },
        {
          alt: '',
          image: images.landingPageCarousel4.childImageSharp.gatsbyImageData,
        },
        {
          alt: '',
          image: images.landingPageCarousel5.childImageSharp.gatsbyImageData,
        },
      ],
      heroImage: images.heroImage.childImageSharp.gatsbyImageData,
      introduction: `Whether it's the opening of a retail store or a food truck's first day of trading, the way in which you launch a new business can be the key to ensuring long-term success. But when you're doing everything yourself – from marketing to bookkeeping – things can feel a little overwhelming. The solution is to work smart and deploy tools to help you make the best decisions from day one. By bringing together your invoice data and marketing tools in one place, QuickBooks and Mailchimp can empower business owners to speed up sales,  accelerate growth and serve their customers better.`,
      partnersTitle: 'Endeavor partners',
      sliderCaption: `‘That's probably the only thing that hasn't changed - we all still fake it till you make it. And I think it's going pretty well so far.’`,
      sliderCaptionAtrribution: '– JAMES TIMMINS, UTTER WAFFLE',
    },
  };
  return {
    QUICKBOOKS,
  };
};

export default QuickbooksData;
